export default __webpack_public_path__ + "media/Education.5741696c.svg";